import { Alert, List, Text } from '@mantine/core'
import { IconGitCompare } from '@tabler/icons-react'
import type { Divergencia } from '@/api/waf'

function valor(v: unknown): string {
  return typeof v === 'string' ? v : JSON.stringify(v)
}

/**
 * Aviso de que a AWS difere do código do stage (spec 2026-10-14 D3). Sem
 * divergência não renderiza nada: não existe selo de "sincronizado", porque a
 * comparação cobre só os campos do módulo e quem decide é o plan do stage.
 */
export function FaixaDivergencia({ stage, divergencias }: { stage: string; divergencias: Divergencia[] }) {
  if (!divergencias.length) return null
  return (
    <Alert
      role="status"
      color="yellow"
      variant="light"
      icon={<IconGitCompare size={20} />}
      title={<>A AWS difere do código do stage <Text span ff="monospace" fw={600}>{stage}</Text> em:</>}
    >
      <List size="sm" spacing={4}>
        {divergencias.map(d => (
          <List.Item key={d.campo}>
            <Text span ff="monospace" size="sm">{d.campo}</Text>
            {': código '}
            <Text span ff="monospace" size="sm">{valor(d.no_codigo)}</Text>
            {', AWS '}
            <Text span ff="monospace" size="sm">{valor(d.na_aws)}</Text>
            {!d.expressavel && (
              <Text span size="sm" c="dimmed">
                {' '}(o módulo não guarda isso; o próximo apply volta ao código)
              </Text>
            )}
          </List.Item>
        ))}
      </List>
      <Text size="xs" c="dimmed" mt="xs">
        Esta comparação cobre os campos do módulo waf; a palavra final é o plan do stage.
      </Text>
    </Alert>
  )
}
